import AppInfoService from './AppInfoService';
import ApplicationService from './ApplicationService';
import AuthService from './AuthService';
import CacheService from './CacheService';
import FileService from './FileService';
import GraphQLService from './GraphQLService';
import GroupService from './GroupService';
import ImageFileService from './ImageFileService';
import LayerService from './LayerService';
import OpenAPIService from './OpenAPIService';
import RoleService from './RoleService';
import UserService from './UserService';
export class SHOGunAPIClient {
    constructor(opts = {
        url: '/'
    }) {
        this.basePath = opts.url;
        this.keycloak = opts.keycloak;
    }
    cache() {
        if (!this.cacheService) {
            this.cacheService = new CacheService({
                basePath: `${this.basePath}cache`,
                keycloak: this.keycloak
            });
        }
        return this.cacheService;
    }
    info() {
        if (!this.appInfoService) {
            this.appInfoService = new AppInfoService({
                basePath: `${this.basePath}info`,
                keycloak: this.keycloak
            });
        }
        return this.appInfoService;
    }
    application() {
        if (!this.applicationService) {
            this.applicationService = new ApplicationService({
                basePath: `${this.basePath}applications`,
                keycloak: this.keycloak
            });
        }
        return this.applicationService;
    }
    layer() {
        if (!this.layerService) {
            this.layerService = new LayerService({
                basePath: `${this.basePath}layers`,
                keycloak: this.keycloak
            });
        }
        return this.layerService;
    }
    group() {
        if (!this.groupService) {
            this.groupService = new GroupService({
                basePath: `${this.basePath}groups`,
                keycloak: this.keycloak
            });
        }
        return this.groupService;
    }
    user() {
        if (!this.userService) {
            this.userService = new UserService({
                basePath: `${this.basePath}users`,
                keycloak: this.keycloak
            });
        }
        return this.userService;
    }
    role() {
        if (!this.roleService) {
            this.roleService = new RoleService({
                basePath: `${this.basePath}roles`,
                keycloak: this.keycloak
            });
        }
        return this.roleService;
    }
    file() {
        if (!this.fileService) {
            this.fileService = new FileService({
                basePath: `${this.basePath}files`,
                keycloak: this.keycloak
            });
        }
        return this.fileService;
    }
    imagefile() {
        if (!this.imageFileService) {
            this.imageFileService = new ImageFileService({
                basePath: `${this.basePath}imagefiles`,
                keycloak: this.keycloak
            });
        }
        return this.imageFileService;
    }
    auth() {
        if (!this.authService) {
            this.authService = new AuthService({
                basePath: `${this.basePath}sso`,
                keycloak: this.keycloak
            });
        }
        return this.authService;
    }
    graphql() {
        if (!this.graphqlService) {
            this.graphqlService = new GraphQLService({
                basePath: `${this.basePath}graphql`,
                keycloak: this.keycloak
            });
        }
        return this.graphqlService;
    }
    openapi() {
        if (!this.openapiService) {
            this.openapiService = new OpenAPIService({
                basePath: `${this.basePath}`,
                keycloak: this.keycloak
            });
        }
        return this.openapiService;
    }
    getBasePath() {
        return this.basePath;
    }
    setBasePath(basePath) {
        this.basePath = basePath;
    }
    getKeycloak() {
        return this.keycloak;
    }
    setKeycloak(keycloak) {
        this.keycloak = keycloak;
    }
}
export default SHOGunAPIClient;
//# sourceMappingURL=SHOGunAPIClient.js.map